import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformAccess } from '../../../features/users/users.model';

@Component({
  selector: 'app-access-type-selector',
  standalone: false,
  templateUrl: './access-type-selector.component.html',
  styleUrl: './access-type-selector.component.scss'
})
export class AccessTypeSelectorComponent {
  @Input() selectedTypes: PlatformAccess[] = ['BOTH'];
  @Output() typesChange = new EventEmitter<PlatformAccess[]>();

  get selectedAccess(): PlatformAccess {
    return this.selectedTypes && this.selectedTypes.length > 0 ? this.selectedTypes[0] : 'BOTH';
  }

  onSelectionChange(access: PlatformAccess): void {
    this.selectedTypes = [access];
    this.typesChange.emit(this.selectedTypes);
  }
}
